import { GtagConfigParams } from './types';

/**
 * Passed as the configuration parameters to the gtag 'config' command
 */
const config: GtagConfigParams = {
    custom_map: {
        // Tracks the method by which 'add_to_cart' and 'remove_from_cart' events are triggered.
        dimension1: 'cart_update_method',

        // Tracks the type of search which was performed during a 'search' event
        dimension2: 'search_type',
        dimension3: 'action'
    }
};

export default config;
